import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { ArrowLeft, Lock } from "lucide-react";

const AdminLogin = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Sessão iniciada.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Credenciais inválidas.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-white/70 hover:text-[#c0392b] transition-colors mb-10 font-heading tracking-[0.25em] uppercase text-xs"
          data-testid="back-to-site"
        >
          <ArrowLeft size={16} /> Voltar ao Site
        </Link>

        <div className="border border-white/20 p-8 md:p-10">
          <div className="flex items-center gap-3 mb-3">
            <Lock className="text-[#c0392b]" size={18} />
            <span className="font-heading text-[#c0392b] tracking-[0.4em] text-xs uppercase">Área Reservada</span>
          </div>
          <h1 className="font-heading text-white text-5xl uppercase leading-[0.95] mb-8" data-testid="admin-login-title">
            Entrar
          </h1>

          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div>
              <label className="label-uppercase" htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="field"
                placeholder="admin@miguelfaria.photo"
                data-testid="admin-input-email"
                required
              />
            </div>
            <div>
              <label className="label-uppercase" htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="field"
                placeholder="••••••••"
                data-testid="admin-input-password"
                required
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="cta-primary w-full disabled:opacity-50"
              data-testid="admin-login-submit"
            >
              {loading ? "A Entrar…" : "Entrar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
